import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'prg-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.less']
})
export class ConfirmModalComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() confirmLabel: string;
  @Input() confirmClass: string;

  @Output() confirm: EventEmitter<any>;
  @Output() cancel: EventEmitter<any>;

  constructor() {
    this.confirm = new EventEmitter<any>();
    this.cancel = new EventEmitter<any>();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/confirm-modal/confirm-modal.component.ts